<template>
    <div class="c-row" v-bind:class="mode?'c-row--'+mode:''">
        <slot></slot>
    </div>
</template>
<script>
export default {
    props:['mode']
}
</script>
<style lang="scss">
    .c-row{
        display: flex;
        justify-content: space-around;
        &--wrap{
            flex-wrap: wrap;
        }
        label{
            display: block;
            width: 100%;
        }
    }
</style>